import { render } from "./Dentures.vue?vue&type=template&id=57245bdc"
import script from "./Dentures.vue?vue&type=script&lang=js"
export * from "./Dentures.vue?vue&type=script&lang=js"

import "./Dentures.vue?vue&type=style&index=0&id=57245bdc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__